import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// import { Link } from "react-router-dom";
import "./footer.css";


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function FullWidthGrid() {
  // const classes = useStyles();

  return (
    <div >
      <div className="footer">
        <p>ViewNotes - designed by OutSpread</p>
      </div>
    </div>
  );
}
